import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function taskYield() {
  return _taskYield.apply(this, arguments);
}
function _taskYield() {
  _taskYield = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var resolve, p;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!('scheduler' in globalThis &&
          // @ts-ignore
          'yield' in globalThis.scheduler)) {
            _context.next = 4;
            break;
          }
          _context.next = 3;
          return scheduler.yield();
        case 3:
          return _context.abrupt("return");
        case 4:
          resolve = function resolve() {};
          p = new Promise(function (a) {
            resolve = a;
          });
          setTimeout(resolve, 0);
          _context.next = 9;
          return p;
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _taskYield.apply(this, arguments);
}
export default taskYield;